import React from "react";


const ForgotPasswordPage = () => {
  return (
    <>

      {/* ForgotPasswordLayer */}

    </>
  );
};

export default ForgotPasswordPage;
